import React from 'react'
import { Link } from 'react-router-dom'
import config from '../Config'

const SlotsTable = ({ data, onChangeStatus }) => {

    const getPaymentStatus = (slots, status) => {
        if (slots?.length > 0 && status == 0)
            return <span className='badge bg-success'>Available</span>
        else
            return <span className='badge bg-danger'>Not Available</span>
    }

    function getDayId(dayName) {
        switch (dayName?.toLowerCase()) {
            case 'monday': return 1;
            case 'tuesday': return 2;
            case 'wednesday': return 3;
            case 'thursday': return 4;
            case 'friday': return 5;
            case 'saturday': return 6;
            case 'sunday': return 7;
            default: return null;  // Return null if an invalid day is provided
        }
    }


    return (
        <div className='table-responsive'>
            <table className='jean-table table'>
                <tbody>
                    {
                        data?.map((thera, i) => {

                            let slotsLength = 0;
                            if (thera?.slots) {
                                try {
                                    // Check if slots is a string and parse it if necessary
                                    const parsedSlots = Array.isArray(thera?.slots) ? thera?.slots : JSON.parse(thera?.slots);
                                    slotsLength = parsedSlots.length;
                                } catch (e) {
                                    console.error("Error parsing slots:", e);
                                    slotsLength = 0;
                                }
                            }

                            let payment_status = getPaymentStatus(thera?.slots, thera?.status);
                            return (
                                <tr key={thera?.id}>

                                    <td>
                                        <div className='therapist-info ps-2'>
                                            <h4 className='mb-1 fs-5'>Day</h4>
                                            <p className='mb-0'>{thera?.days}</p>
                                        </div>
                                    </td>

                                    <td>
                                        <div className='therapist-info'>
                                            <h4 className='mb-1 fs-5'>Number of Slots</h4>
                                            <p className='mb-0'>{slotsLength}</p>
                                        </div>
                                    </td>

                                    <td>
                                        <div className='therapist-info'>
                                            <h4 className='mb-1 fs-5'>Availability Status</h4>
                                            <p className='mb-0'>{payment_status}</p>
                                        </div>
                                    </td>

                                    <td>
                                        <div className='therapist-info '>
                                            <h4 className='mb-1 fs-5'>Status</h4>
                                            <div className="form-check form-switch form-switch-md d-flex py-0 ms-4 mb-0">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input fs-2"
                                                    checked={Number(thera.status) === 0}
                                                    onChange={() => {
                                                        if (thera?.slots)
                                                            onChangeStatus(thera.id, thera.status)
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </td>

                                    <td>
                                        <div className='d-flex justify-content-end pe-4'>
                                            <Link className="px-4 text-center bg-green py-2  text-white rounded-4" to={`${config.appUrl}add-availability-slots/${thera.id || "0"}/${getDayId(thera.days)}`}>
                                                <i className="icon-pen mr-10"></i>
                                                Add / Edit
                                            </Link>
                                        </div>
                                    </td>
                                </tr>
                            )
                        })
                    }

                    {
                        data?.length === 0 &&
                        <div className="alert alert-success ps-4">Loading days...</div>
                    }
                </tbody>
            </table>
        </div>
    )
}

export default SlotsTable